import {
  addToLocalStorage,
  retrieveLocalStorage,
} from '@common/helpers/localStorage';
import { useToast } from '@react/shared/components/Toast';
import { EBOOK_SEND_EMAIL } from '@sly/core/constants/actionTypes';
import React, { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'sly/services/api';
import { Button, Heading, Link } from 'sly/system';
import Input from 'sly/system/Input';

const SubscribeEmail = () => {
  const { pushSuccess: notifyInfo, pushError: notifyError } = useToast();
  const createAction = useQuery('createUuidAction');

  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hideSection, setHideSection] = useState(false);

  useEffect(() => {
    if (retrieveLocalStorage(EBOOK_SEND_EMAIL)) {
      setHideSection(true);
    }
  }, []);

  const onSubmit = useCallback(() => {
    setIsLoading(true);
    createAction({
      type: 'UUIDAction',
      attributes: {
        actionType: EBOOK_SEND_EMAIL,
        actionInfo: { email: value },
      },
    })
      .then(() => {
        notifyInfo('Success');
        setValue('');
        // Add entry to local storage
        addToLocalStorage(EBOOK_SEND_EMAIL, true);
      })
      .catch((err) => {
        notifyError(err?.body?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [value, createAction, notifyError, notifyInfo]);

  if (hideSection) {
    return null;
  }

  return (
    <>
      <div
        className='bg-harvest-lighter-90 py-xxl px-m md:py-xxxl md:px-[auto] lg:py-xxl lg:px-m'
        data-tp-id='gen-div-4b39a185-eda2-4576-908d-f88cf094bf7b'
      >
        <Heading
          className='font-t-l mb-l text-center'
          data-tp-id='gen-Heading-ea35a6cf-6f63-4147-a1ad-f9d416cfe3e2'
        >
          Sign up for our Healthy Aging Handbook
        </Heading>

        <p className='font-b-l mb-l md:mx-auto md:w-[42.5rem] md:text-center'>
          Seniorly’s Senior Living experts created a comprehensive handbook to
          help people age happily while ensuring they love where they live.
          Enter your email address below to receive your copy and learn more
          about Healthy Aging and Senior Living.*
        </p>

        <div
          className='mx-auto mb-l md:flex md:w-[31.5rem]'
          data-tp-id='gen-div-bf61410e-6146-48a6-b0d4-562d8c01ff3d'
        >
          <Input
            className='!w-full grow-[1] md:w-auto'
            value={value}
            onChange={(evt) => setValue(evt.target.value)}
            placeholder='Your email address'
            data-tp-id='gen-Input-8b15b481-1c19-409b-a4f1-e5a06caa59a2'
          />
          <Button
            className='font-b-m mt-s w-full grow-0 overflow-visible border-none py-s px-l md:mt-0 md:ml-s md:w-auto'
            disabled={isLoading || !value.trim()}
            onClick={onSubmit}
            data-tp-id='gen-Button-a1e4c40f-8d40-47dc-8633-8983bb2de419'
          >
            Sign up
          </Button>
        </div>
        <p className='font-b-xs mx-auto text-center md:w-[42.5rem]'>
          *By submitting your email address above, you consent to receive
          occasional email communications from Seniorly, including educational
          content and tips, newsletters, and other relevant updates and
          offerings. You can unsubscribe at any time and we will never sell or
          distribute your email address to a third party. You can view our
          Privacy Policy{' '}
          <Link
            to='/privacy'
            textDecordation='underline'
            color='blue.base'
            eventProps={{
              location: 'subscribeEmail',
            }}
            data-tp-id='gen-Link-b837491a-ccab-4340-a8db-78771b5bc468'
          >
            here
          </Link>
          .
        </p>
      </div>

      <hr />
    </>
  );
};

export default SubscribeEmail;
